var _rect, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _path11, _path12, _path13, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _path14, _path15, _path16, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17, _path17, _path18, _path19, _tspan18, _tspan19, _tspan20, _tspan21, _tspan22, _tspan23, _path20, _path21, _path22, _tspan24, _tspan25, _tspan26, _tspan27, _tspan28, _tspan29, _path23, _path24, _path25, _tspan30, _tspan31, _tspan32, _tspan33, _tspan34, _tspan35, _path26, _path27, _path28, _tspan36, _tspan37, _tspan38, _tspan39, _tspan40, _tspan41, _tspan42, _path29, _path30, _path31, _tspan43, _tspan44, _tspan45, _tspan46, _path32, _path33, _path34, _tspan47, _tspan48, _tspan49, _tspan50, _tspan51, _tspan52, _path35, _g3, _g4, _tspan53, _tspan54;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1718,
    height: 924,
    viewBox: "0 0 1718 924",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1718,
    height: 924,
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g_svg"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g_bkg"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 2",
    width: 1718,
    height: 923,
    fill: "#09516C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_main"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 58"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1717.5 0H0V923.25H1717.5V0Z",
    fill: "#09516C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g_info"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line1",
    d: "M187.699 613.57H299.488",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line2",
    d: "M359.332 613.57H470.773",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Line3",
    d: "M530.59 613.57H642.961",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Line4",
    d: "M702.814 613.57H814.33",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Line5",
    d: "M874.172 613.57H984.827",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Line6",
    d: "M1044.67 613.57H1157.47",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Line7",
    d: "M1217.32 613.57H1328.84",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Line8",
    d: "M1388.68 613.57H1503.08",
    stroke: "white",
    strokeWidth: 6,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group1"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle1",
    d: "M157.793 644.436C174.154 644.436 187.418 631.172 187.418 614.811C187.418 598.45 174.154 585.186 157.793 585.186C141.432 585.186 128.168 598.45 128.168 614.811C128.168 631.172 141.432 644.436 157.793 644.436Z",
    fill: "#2D5A6A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle1",
    d: "M157.594 636.262C169.399 636.262 178.969 626.693 178.969 614.887C178.969 603.082 169.399 593.512 157.594 593.512C145.789 593.512 136.219 603.082 136.219 614.887C136.219 626.693 145.789 636.262 157.594 636.262Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month1",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 103,
    y: 669.5
  }, "January | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date1",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 147,
    y: 620.318
  }, "31"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis1"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis1Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 55,
    y: 409.909
  }, "Begun buying"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis1Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 55,
    y: 445.909
  }, " shares of the "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis1Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 83,
    y: 481.909
  }, " company ")))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow1",
    d: "M156.562 585.186V546.885",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group2"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle2",
    d: "M329.543 645.268C345.904 645.268 359.168 632.005 359.168 615.643C359.168 599.282 345.904 586.018 329.543 586.018C313.182 586.018 299.918 599.282 299.918 615.643C299.918 632.005 313.182 645.268 329.543 645.268Z",
    fill: "#2D5A6A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle2",
    d: "M350.719 615.72C350.719 627.525 341.149 637.095 329.344 637.095C317.539 637.095 307.969 627.525 307.969 615.72C307.969 603.915 317.539 594.345 329.344 594.345C341.149 594.345 350.719 603.915 350.719 615.72Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month2",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 291.842,
    y: 561.608
  }, "April | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date2",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 317,
    y: 621.318
  }, "04"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis2"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis2Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 168,
    y: 767.909
  }, "Acquired a 9.1% stake "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis2Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 196,
    y: 803.909
  }, "in Twitter, making "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis2Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 202,
    y: 839.909
  }, "Musk the largest "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis2Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 236,
    y: 875.909
  }, "shareholder")))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow2",
    d: "M330.562 642.638V680.939",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group3"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle3",
    d: "M500.398 644.436C516.76 644.436 530.023 631.172 530.023 614.811C530.023 598.45 516.76 585.186 500.398 585.186C484.037 585.186 470.773 598.45 470.773 614.811C470.773 631.172 484.037 644.436 500.398 644.436Z",
    fill: "#2D5A6A"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle3",
    d: "M500.199 636.263C512.004 636.263 521.574 626.693 521.574 614.888C521.574 603.082 512.004 593.513 500.199 593.513C488.394 593.513 478.824 603.082 478.824 614.888C478.824 626.693 488.394 636.263 500.199 636.263Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month3",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 471,
    y: 667.5
  }, "April | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date3",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 490,
    y: 620.318
  }, "11"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis3"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis3Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 364,
    y: 374.909
  }, "Twitter offers Musk"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis3Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 369,
    y: 410.909
  }, "a seat on its board"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis3Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 366,
    y: 446.909
  }, "of directors, but he "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis3Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 441,
    y: 482.909
  }, "declines  ")))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow3",
    d: "M499.168 585.186V546.885",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group4"
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle4",
    d: "M673.043 644.436C689.404 644.436 702.668 631.172 702.668 614.811C702.668 598.45 689.404 585.186 673.043 585.186C656.682 585.186 643.418 598.45 643.418 614.811C643.418 631.172 656.682 644.436 673.043 644.436Z",
    fill: "#2D5A6A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle4",
    d: "M672.844 636.263C684.649 636.263 694.219 626.693 694.219 614.888C694.219 603.082 684.649 593.513 672.844 593.513C661.039 593.513 651.469 603.082 651.469 614.888C651.469 626.693 661.039 636.263 672.844 636.263Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month4",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan18 || (_tspan18 = /*#__PURE__*/React.createElement("tspan", {
    x: 635.322,
    y: 560.776
  }, "April | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date4",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan19 || (_tspan19 = /*#__PURE__*/React.createElement("tspan", {
    x: 663,
    y: 621.318
  }, "14"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis4"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis4Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan20 || (_tspan20 = /*#__PURE__*/React.createElement("tspan", {
    x: 587,
    y: 768.909
  }, "Musk makes"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis4Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan21 || (_tspan21 = /*#__PURE__*/React.createElement("tspan", {
    x: 571,
    y: 804.909
  }, "an offer to buy "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis4Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan22 || (_tspan22 = /*#__PURE__*/React.createElement("tspan", {
    x: 569,
    y: 840.909
  }, "Twitter for $44  "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis4Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan23 || (_tspan23 = /*#__PURE__*/React.createElement("tspan", {
    x: 633,
    y: 876.909
  }, "billion   ")))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow4",
    d: "M674.062 641.806V680.107",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group5"
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle5",
    d: "M843.895 646.102C860.256 646.102 873.52 632.838 873.52 616.477C873.52 600.115 860.256 586.852 843.895 586.852C827.533 586.852 814.27 600.115 814.27 616.477C814.27 632.838 827.533 646.102 843.895 646.102Z",
    fill: "#2D5A6A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle5",
    d: "M843.699 637.928C855.504 637.928 865.074 628.358 865.074 616.553C865.074 604.747 855.504 595.178 843.699 595.178C831.894 595.178 822.324 604.747 822.324 616.553C822.324 628.358 831.894 637.928 843.699 637.928Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month5",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan24 || (_tspan24 = /*#__PURE__*/React.createElement("tspan", {
    x: 806.68,
    y: 664.431
  }, "April |2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date5",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan25 || (_tspan25 = /*#__PURE__*/React.createElement("tspan", {
    x: 832,
    y: 622.318
  }, "25"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis5"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis5Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan26 || (_tspan26 = /*#__PURE__*/React.createElement("tspan", {
    x: 782,
    y: 375.909
  }, "Board of "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis5Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan27 || (_tspan27 = /*#__PURE__*/React.createElement("tspan", {
    x: 780,
    y: 411.909
  }, "directors"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis5Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan28 || (_tspan28 = /*#__PURE__*/React.createElement("tspan", {
    x: 695,
    y: 447.909
  }, "unanimously accepts"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis5Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan29 || (_tspan29 = /*#__PURE__*/React.createElement("tspan", {
    x: 767,
    y: 483.909
  }, "Musk offer  ")))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow5",
    d: "M841.773 586.852V548.55",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group6"
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle6",
    d: "M1015.64 644.436C1032.01 644.436 1045.27 631.172 1045.27 614.811C1045.27 598.45 1032.01 585.186 1015.64 585.186C999.283 585.186 986.02 598.45 986.02 614.811C986.02 631.172 999.283 644.436 1015.64 644.436Z",
    fill: "#2D5A6A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle6",
    d: "M1015.45 636.263C1027.25 636.263 1036.82 626.693 1036.82 614.888C1036.82 603.082 1027.25 593.513 1015.45 593.513C1003.64 593.513 994.074 603.082 994.074 614.888C994.074 626.693 1003.64 636.263 1015.45 636.263Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Date6",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan30 || (_tspan30 = /*#__PURE__*/React.createElement("tspan", {
    x: 1007,
    y: 622.318
  }, "17"))), /*#__PURE__*/React.createElement("g", {
    id: "mG6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month6",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan31 || (_tspan31 = /*#__PURE__*/React.createElement("tspan", {
    x: 981.557,
    y: 561.675
  }, "May | 2022")))), /*#__PURE__*/React.createElement("g", {
    id: "Dis6"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis6Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan32 || (_tspan32 = /*#__PURE__*/React.createElement("tspan", {
    x: 907,
    y: 771.909
  }, "Musk says he is"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis6Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan33 || (_tspan33 = /*#__PURE__*/React.createElement("tspan", {
    x: 853,
    y: 807.909
  }, "temporarily suspending "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis6Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan34 || (_tspan34 = /*#__PURE__*/React.createElement("tspan", {
    x: 861,
    y: 843.909
  }, "the Twitter acquisition"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis6Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan35 || (_tspan35 = /*#__PURE__*/React.createElement("tspan", {
    x: 987,
    y: 879.909
  }, "deal   ")))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow6",
    d: "M1017.56 642.638V680.939",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group7"
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle7",
    d: "M1187.39 645.269C1203.76 645.269 1217.02 632.005 1217.02 615.644C1217.02 599.282 1203.76 586.019 1187.39 586.019C1171.03 586.019 1157.77 599.282 1157.77 615.644C1157.77 632.005 1171.03 645.269 1187.39 645.269Z",
    fill: "#2D5A6A"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle7",
    d: "M1187.2 637.095C1199 637.095 1208.57 627.525 1208.57 615.72C1208.57 603.915 1199 594.345 1187.2 594.345C1175.39 594.345 1165.82 603.915 1165.82 615.72C1165.82 627.525 1175.39 637.095 1187.2 637.095Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month7",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan36 || (_tspan36 = /*#__PURE__*/React.createElement("tspan", {
    x: 1154.39,
    y: 664.431
  }, "July | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date7",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan37 || (_tspan37 = /*#__PURE__*/React.createElement("tspan", {
    x: 1175,
    y: 621.318
  }, "08"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis7"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis7Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan38 || (_tspan38 = /*#__PURE__*/React.createElement("tspan", {
    x: 1030,
    y: 339.909
  }, "Musk tries to cancel his "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis7Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan39 || (_tspan39 = /*#__PURE__*/React.createElement("tspan", {
    x: 1014,
    y: 375.909
  }, "agreement by agreeing to "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis7Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan40 || (_tspan40 = /*#__PURE__*/React.createElement("tspan", {
    x: 1075,
    y: 411.909
  }, "pay an additional "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis7Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan41 || (_tspan41 = /*#__PURE__*/React.createElement("tspan", {
    x: 1020,
    y: 447.909
  }, "$1 billion if he terminates "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis7Text5",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan42 || (_tspan42 = /*#__PURE__*/React.createElement("tspan", {
    x: 1138,
    y: 483.909
  }, "the deal    ")))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow7",
    d: "M1187.96 586.852V548.55",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group8"
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle8",
    d: "M1358.25 644.436C1374.62 644.436 1387.88 631.172 1387.88 614.811C1387.88 598.45 1374.62 585.186 1358.25 585.186C1341.89 585.186 1328.63 598.45 1328.63 614.811C1328.63 631.172 1341.89 644.436 1358.25 644.436Z",
    fill: "#2D5A6A"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle8",
    d: "M1358.06 636.263C1369.86 636.263 1379.43 626.693 1379.43 614.888C1379.43 603.082 1369.86 593.513 1358.06 593.513C1346.25 593.513 1336.68 603.082 1336.68 614.888C1336.68 626.693 1346.25 636.263 1358.06 636.263Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG8"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month8",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan43 || (_tspan43 = /*#__PURE__*/React.createElement("tspan", {
    x: 1325.76,
    y: 561.675
  }, "October | 2022")))), /*#__PURE__*/React.createElement("text", {
    id: "Date8",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan44 || (_tspan44 = /*#__PURE__*/React.createElement("tspan", {
    x: 1347,
    y: 622.318
  }, "27"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis8"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis8Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan45 || (_tspan45 = /*#__PURE__*/React.createElement("tspan", {
    x: 1420,
    y: 448.909
  }, "Change Twitter"))), /*#__PURE__*/React.createElement("text", {
    id: "Dis8Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan46 || (_tspan46 = /*#__PURE__*/React.createElement("tspan", {
    x: 1499,
    y: 484.909
  }, "logo")))), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow8",
    d: "M1361.96 642.638V680.939",
    stroke: "white",
    strokeWidth: 2.25
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group9"
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "OutCircle9",
    d: "M1532.69 646.102C1549.05 646.102 1562.31 632.838 1562.31 616.477C1562.31 600.115 1549.05 586.852 1532.69 586.852C1516.33 586.852 1503.06 600.115 1503.06 616.477C1503.06 632.838 1516.33 646.102 1532.69 646.102Z",
    fill: "#2D5A6A"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "MidCircle9",
    d: "M1532.48 637.927C1544.29 637.927 1553.86 628.358 1553.86 616.552C1553.86 604.747 1544.29 595.177 1532.48 595.177C1520.68 595.177 1511.11 604.747 1511.11 616.552C1511.11 628.358 1520.68 637.927 1532.48 637.927Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mG9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Month9",
    fill: "black",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 22,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan47 || (_tspan47 = /*#__PURE__*/React.createElement("tspan", {
    x: 1467.74,
    y: 664.989
  }, "July | 2023")))), /*#__PURE__*/React.createElement("text", {
    id: "Date9",
    fill: "#070707",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 18.75,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan48 || (_tspan48 = /*#__PURE__*/React.createElement("tspan", {
    x: 1522,
    y: 622.318
  }, "25"))), /*#__PURE__*/React.createElement("g", {
    id: "Dis9"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Dis9Text1",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan49 || (_tspan49 = /*#__PURE__*/React.createElement("tspan", {
    x: 1273.27,
    y: 771.909
  }, "Acquisition is  "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis9Text2",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan50 || (_tspan50 = /*#__PURE__*/React.createElement("tspan", {
    x: 1303.17,
    y: 807.909
  }, "finalized.   "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis9Text3",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan51 || (_tspan51 = /*#__PURE__*/React.createElement("tspan", {
    x: 1269.93,
    y: 840.909
  }, "Musk becomes "))), /*#__PURE__*/React.createElement("text", {
    id: "Dis9Text4",
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 30,
    fontWeight: 300,
    letterSpacing: "0em"
  }, _tspan52 || (_tspan52 = /*#__PURE__*/React.createElement("tspan", {
    x: 1293.81,
    y: 879.909
  }, "new owner.   ")))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Arrow9",
    d: "M1532.35 586.852V548.55",
    stroke: "white",
    strokeWidth: 2.25
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Logo Bird"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M191.402 132.955C186.887 134.805 182.103 136.022 177.205 136.568C182.352 133.723 186.215 129.234 188.074 123.938C183.22 126.597 177.914 128.467 172.384 129.467C168.69 125.753 163.78 123.282 158.42 122.439C153.06 121.595 147.55 122.427 142.75 124.803C137.951 127.18 134.13 130.967 131.886 135.577C129.641 140.186 129.098 145.356 130.341 150.282C120.544 149.832 110.956 147.482 102.193 143.381C93.4293 139.28 85.6833 133.52 79.4515 126.469C77.2548 129.943 76.102 133.903 76.1148 137.934C76.1163 141.694 77.119 145.395 79.0345 148.705C80.9508 152.015 83.7183 154.832 87.0903 156.902C83.173 156.778 79.3405 155.802 75.8995 154.054V154.329C75.9168 159.608 77.899 164.72 81.508 168.792C85.117 172.865 90.1308 175.649 95.6958 176.669C93.5838 177.214 91.4028 177.494 89.2105 177.501C87.6498 177.491 86.0935 177.351 84.559 177.085C86.1625 181.622 89.2428 185.583 93.3738 188.418C97.504 191.253 102.48 192.821 107.611 192.905C98.8428 199.247 88.0503 202.681 76.9465 202.664C74.9794 202.664 73.0138 202.556 71.0605 202.339C82.3803 209.023 95.5113 212.567 108.917 212.555C154.323 212.555 179.174 177.842 179.174 147.734C179.174 146.744 179.174 145.761 179.084 144.795C183.932 141.595 188.11 137.597 191.411 132.997",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Logo x"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1543.7 134.804V200C1543.7 202.14 1544.15 204.259 1545.03 206.236C1545.92 208.214 1547.21 210.011 1548.83 211.524C1550.45 213.038 1552.39 214.237 1554.51 215.056C1556.63 215.874 1558.91 216.295 1561.22 216.294H1631.26C1635.9 216.294 1640.35 214.577 1643.63 211.521C1646.92 208.466 1648.76 204.321 1648.76 200V134.804C1648.76 132.663 1648.31 130.543 1647.43 128.565C1646.55 126.587 1645.26 124.79 1643.64 123.276C1642.01 121.762 1640.08 120.561 1637.96 119.741C1635.83 118.922 1633.55 118.5 1631.26 118.5H1561.22C1558.91 118.499 1556.63 118.92 1554.51 119.739C1552.38 120.558 1550.45 121.759 1548.83 123.273C1547.2 124.786 1545.91 126.585 1545.03 128.564C1544.15 130.542 1543.7 132.662 1543.7 134.804ZM1566.56 139.458H1586.4L1600.51 158.109L1617.62 139.458H1623.88L1603.3 161.839L1628.63 195.344H1608.79L1592.42 173.695L1572.56 195.344H1566.3L1589.56 169.966L1566.56 139.458ZM1576.13 144.112L1611.41 190.682H1619.08L1583.79 144.112H1576.13Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1591.3 168.134L1566.34 195.344H1572.6L1593.85 172.156C1592.96 170.816 1592.15 169.466 1591.3 168.134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1623.81 193.013H1610.11L1571.33 141.789H1585.12L1623.81 193.013Z",
    stroke: "white",
    strokeWidth: 4.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1600.66 164.704L1623.79 139.458H1617.61L1598.14 160.673C1599.07 161.964 1599.84 163.346 1600.66 164.704Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Title"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Title1"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 44,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan53 || (_tspan53 = /*#__PURE__*/React.createElement("tspan", {
    x: 385,
    y: 196.682
  }, "Twitter&#39;s Journey 2022 : A Transformation to X"))), /*#__PURE__*/React.createElement("text", {
    fill: "white",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Inter",
    fontSize: 72,
    fontWeight: "bold",
    letterSpacing: "0em"
  }, _tspan54 || (_tspan54 = /*#__PURE__*/React.createElement("tspan", {
    x: 1387.5,
    y: 196.682
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.fedafdcafaedb03bed2484f93782df7d.svg";
export { ForwardRef as ReactComponent };